import styled from 'styled-components';
import { v2Color } from '@theme/v2';

export const Root = styled.div`
  position: relative;
  width: 100%;
`;

export const Field = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 11px;
  background: ${({ $submitting }) => ($submitting ? '#F5F6F8' : '#fff')};
  border: 1px solid ${({ $focused }) => ($focused ? v2Color('#006169') : '#d9d9d9')};
  border-radius: 6px;
  box-shadow: ${({ $focused }) => ($focused ? '0 0 0 2px #E1F7EA' : 'none')};
  cursor: ${({ $submitting }) => ($submitting ? 'not-allowed' : 'auto')};
`;

export const IconSlot = styled.span`
  display: inline-grid;
  place-content: center;
  color: ${({ $focused }) => ($focused ? v2Color('#006169', 'text') : 'rgb(150,150,150)')};
`;

export const InputWrap = styled.span`
  position: relative;
  display: block;
  flex: 1;
  min-width: 0;
`;

export const PlaceholderLayer = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
  pointer-events: none;
`;

export const PlaceholderText = styled.span`
  display: block;
  width: 100%;
  color: rgb(157,157,157);
  font-size: 14px;
  line-height: 1.5715;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: ${({ $rotating, $phIndex }) => ($rotating ? ($phIndex === 0 ? 1 : 0) : 1)};
  transition: opacity .45s ease;
`;

export const PlaceholderAlt = styled.span`
  position: absolute;
  inset-block-start: 50%;
  inset-inline-start: 0;
  display: block;
  width: 100%;
  color: rgb(157,157,157);
  font-size: 14px;
  line-height: 1.5715;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: ${({ $phIndex }) => ($phIndex === 1 ? 1 : 0)};
  transform: translateY(-50%);
  transition: opacity .45s ease;
`;

export const Input = styled.input`
  position: relative;
  width: 100%;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5715;
  color: ${({ $submitting }) => ($submitting ? 'rgb(170,170,170)' : 'rgba(0,0,0,0.88)')};
  cursor: ${({ $submitting }) => ($submitting ? 'not-allowed' : 'text')};
`;

export const Dropdown = styled.div`
  position: absolute;
  inset-block-start: calc(100% + 6px);
  inset-inline: 0;
  z-index: 20;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  box-shadow: rgba(16,24,40,0.12) 0px 10px 26px;
  overflow: hidden;
`;

export const DropdownHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 16px 8px;
`;

export const RecentLabel = styled.span`
  color: rgb(130,138,142);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const BrowseHint = styled.span`
  color: rgb(170,170,170);
  font-size: 11px;
`;

export const Row = styled.span`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 13px 16px;
  border-block-start: 1px solid #f5f5f5;
  background: ${({ $active }) => ($active ? '#FAFBFC' : 'transparent')};
  cursor: pointer;
`;

export const RowMain = styled.span`
  display: grid;
  gap: 7px;
  min-width: 0;
  flex: 1;
`;

export const RowTopLine = styled.span`
  display: flex;
  align-items: center;
  gap: 9px;
  flex-wrap: wrap;
`;

export const RowNumber = styled.span`
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
`;

export const IssuedText = styled.span`
  color: rgb(150,150,150);
  font-size: 11.5px;
`;

export const ChipsLine = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

export const Chip = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  background: #F6F7F9;
  color: rgb(112,112,112);
  font-size: 11.5px;
  font-weight: 600;
  white-space: nowrap;
`;

export const Price = styled.span`
  flex: 0 0 auto;
  padding-block-start: 1px;
  font-size: 14px;
  font-weight: 700;
  color: ${({ $active }) => ($active ? v2Color('#006169', 'text') : v2Color('#272B41', 'text'))};
  white-space: nowrap;
`;

export const ChevronSlot = styled.span`
  display: inline-grid;
  place-content: center;
  flex: 0 0 auto;
  color: ${v2Color('#006169', 'text')};
`;

export const Footer = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 16px;
  border-block-start: 1px solid #f0f0f0;
  background: rgb(250,250,251);
`;

export const FooterCount = styled.span`
  color: rgb(112,112,112);
  font-size: 12px;
`;

export const ViewAllButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  background: transparent;
  border: 0;
  color: ${v2Color('#006169', 'text')};
  font-family: inherit;
  font-weight: 600;
  font-size: 12.5px;
  white-space: nowrap;
  cursor: pointer;
`;

export const NumberText = styled.span`
  color: ${({ $highlight }) => ($highlight ? v2Color('#006169', 'text') : v2Color('#272B41', 'text'))};
`;

export const NumberDim = styled.span`
  color: rgb(150,150,150);
  font-weight: 600;
`;

export const NumberMark = styled.span`
  background: #FFF4CE;
`;
